
export function initNavigation() {
    const checkbox = document.querySelector('input[type="checkbox"][role="menuitemcheckbox"]');
    if (checkbox) {
        checkbox.addEventListener('change', (event) => {
            const target = event.target as HTMLInputElement;
            if (target.checked) {
                document.body.classList.add('menu-open');
            } else {
                document.body.classList.remove('menu-open');
            }
        });
    }
}
